<template>
    <div>
        <iframe v-if="ehPerfilFornecedor" class="manual-box" id="box-fornecedor" title="manual"
                src="https://manualize.com.br/categoria_compra_direta/fornecedor-compra-sem-disputa"/>
    </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'ManualCompraDiretaFornecedor',
    data() {
        return {
            menuAnteriorRetraido: false
        }
    },
    computed: {
        ...mapState(['loki']),
        ehPerfilFornecedor() {
            return this.$store.state.loki.user.type === 'EXTERNO'
        },
    },
    mounted() {
        this.menuAnteriorRetraido = this.$store.state.loki.asideClosed
        this.$store.state.loki.asideClosed = true
    },
    beforeDestroy(){
        this.$store.state.loki.asideClosed = this.menuAnteriorRetraido
    }
}
</script>

<style scoped lang="stylus">
    iframe
        border 0px
        margin-left 0px
        height 1100px
        margin-top 0px
        width 100%
</style>
